import { IoCopyOutline } from 'react-icons/io5';
import { Loader } from '@piggytechng/component-library';
import SideSheet from '../../../../../components/NewSideSheet';
import { copyToClipboard, formatToNaira } from '../../../../../helpers/utils';
import { formatIpoDate, getIpoApiStatusTag, getIpoUnitPrice } from '../../../../../helpers/utils/investify';
import { IpoSubscriptionDetailsProps } from '../../../../../types';
import { getIpoIdentifierTag } from './ipoStatus';
import './IpoTab.scss';

const Row = ({ label, value, copyable }: { label: string; value?: string | null; copyable?: boolean }) => (
  <div className="ipo-details__row">
    <span className="ipo-details__label">{label}</span>
    <span className="ipo-details__value">
      {value || '—'}
      {copyable && value && (
        <IoCopyOutline size={16} className="pointer" onClick={() => copyToClipboard(label, value)} />
      )}
    </span>
  </div>
);

const IpoSubscriptionDetails = ({ show, onClose, data, isLoading }: IpoSubscriptionDetailsProps) => {
  if (!data && !isLoading) return null;

  const status = getIpoApiStatusTag(data?.status);
  const chn = getIpoIdentifierTag(data?.chnStatus);
  const cscs = getIpoIdentifierTag(data?.cscsStatus);
  const unitPrice = data ? getIpoUnitPrice(data.subscriptionAmount, data.numberOfUnits) : 0;

  return (
    <SideSheet active={show} onClose={onClose} title="Subscription Details" subTitle={''}>
      {isLoading || !data ? (
        <div className="ipo-details__loader">
          <Loader color="#0F60D6" />
        </div>
      ) : (
        <div className="ipo-details">
          <div className="ipo-details__summary">
            <h3>{data.offerName || 'Public Offer'}</h3>
            <p className={`mode ${status.tagClass}`}>{status.label}</p>
          </div>

          <div className="ipo-details__figures">
            <div>
              <p>Amount</p>
              <h4>{formatToNaira(Number(data.subscriptionAmount || 0))}</h4>
            </div>
            <div>
              <p>Units</p>
              <h4>{Number(data.numberOfUnits || 0).toLocaleString()}</h4>
            </div>
            <div>
              <p>Unit Price</p>
              <h4>{formatToNaira(unitPrice)}</h4>
            </div>
          </div>

          <section>
            <h5>Subscription</h5>
            <Row label="Subscription ID" value={String(data.id)} copyable />
            <Row label="Offer ID" value={data.offerId} copyable />
            <Row label="Submitted" value={formatIpoDate(data.submissionDate, true)} />
            <Row label="Opening Date" value={formatIpoDate(data.openingDate)} />
            <Row label="Processing" value={data.isProcessing ? 'Yes' : 'No'} />
            <Row label="Needs Reconciliation" value={data.needsReconciliation ? 'Yes' : 'No'} />
            {data.rawStatus && <Row label="Provider Status" value={data.rawStatus} />}
            {data.lastError && <Row label="Last Error" value={data.lastError} />}
          </section>

          <section>
            <h5>Investor identifiers</h5>
            <div className="ipo-details__row">
              <span className="ipo-details__label">CHN Status</span>
              <span className="ipo-details__value">
                <p className={`mode ${chn.tagClass}`}>{chn.label}</p>
              </span>
            </div>
            <Row label="CHN" value={data.chn?.trim()} copyable />
            <div className="ipo-details__row">
              <span className="ipo-details__label">CSCS Status</span>
              <span className="ipo-details__value">
                <p className={`mode ${cscs.tagClass}`}>{cscs.label}</p>
              </span>
            </div>
            <Row label="CSCS" value={data.cscs?.trim()} copyable />
          </section>

          <section>
            <h5>Provider References</h5>
            <Row label="Provider" value={data.provider} />
            <Row label="Provider Reference" value={data.providerSubscriptionId} copyable />
          </section>
        </div>
      )}
    </SideSheet>
  );
};

export default IpoSubscriptionDetails;
